"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFontFacesDeclaration = void 0;
const getFontUrl = (fileName) => `https://static.modernatx.com/fonts/${fileName}.woff2`;
const getFontFace = (family, url, weight, italicized = false) => `
      @font-face {
          font-family: "${family}";
          font-display: block;
          font-style: ${italicized ? "italic" : "normal"};
          font-weight: ${weight};
          src: url(${url}) format("woff2");
      }
  `;
const getVariableFontFace = (family, url, italicized = false) => `
      @font-face {
          font-family: "${family}";
          font-display: block;
          font-style: ${italicized ? "italic" : "normal"};
          font-weight: 100 1000;
          src: url(${url}) format("woff2 supports variations"), url(${url}) format("woff2-variations");
      }
  `;
const getFontFacesDeclaration = () => {
    const fontFacesDeclaration = `
  ${getFontFace("Aeonik", getFontUrl("Aeonik-Black"), 600)}
  ${getFontFace("Aeonik", getFontUrl("Aeonik-BlackItalic"), 600, true)}
  ${getFontFace("Aeonik", getFontUrl("Aeonik-Bold"), 700)}
  ${getFontFace("Aeonik", getFontUrl("Aeonik-BoldItalic"), 700, true)}
  ${getFontFace("Aeonik", getFontUrl("Aeonik-Light"), 300)}
  ${getFontFace("Aeonik", getFontUrl("Aeonik-LightItalic"), 300, true)}
  ${getFontFace("Aeonik", getFontUrl("Aeonik-Medium"), 500)}
  ${getFontFace("Aeonik", getFontUrl("Aeonik-MediumItalic"), 500, true)}
  ${getFontFace("Aeonik", getFontUrl("Aeonik-Regular"), 400)}
  ${getFontFace("Aeonik", getFontUrl("Aeonik-RegularItalic"), 400, true)}
  ${getVariableFontFace("NotoSans", getFontUrl("NotoSans"), false)}
  ${getVariableFontFace("NotoSans", getFontUrl("NotoSansItalic"), true)}
  ${getVariableFontFace("NotoSansJP", getFontUrl("NotoSansJP"), false)}
  ${getVariableFontFace("NotoSansKR", getFontUrl("NotoSansKR"), false)}
  ${getVariableFontFace("RobotoMono", getFontUrl("RobotoMono"), false)}
  ${getVariableFontFace("RobotoMono", getFontUrl("RobotoMonoItalic"), true)}
`;
    return fontFacesDeclaration.replace(/[\n\s]+/g, " ");
};
exports.getFontFacesDeclaration = getFontFacesDeclaration;
//# sourceMappingURL=index.js.map